import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=0b1bf083&"
import script from "./UserProfilePage.vue?vue&type=script&lang=js&"
export * from "./UserProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports